import { gql } from 'graphql-request';
import { COUNTRY_FRAGMENT } from '@app/model/refdata/service/RefDataGraphqlFragments';
import { ROOM_FRAGMENT } from '@app/model/hotel/service/HotelGraphQLFragments';


export const SEARCH_HOTEL_WITHIN_RADIUS_RESULT_FRAGMENT = gql`
    ${COUNTRY_FRAGMENT}
    ${ROOM_FRAGMENT}
	fragment SearchHotelWithinRadiusResultFragment on SearchHotelWithinRadiusResult {
      id
      name
      type
      creationDate
      hotelUrl
      imageUrl
      location {
          country {
              ...CountryFields
          }
          address
          city
          coordinates {
              lat
              lng
          }
      }
      isSuperhost
      reviewScore {
          sum
          average
      }
      facilities
      statistics {
          average_night_rate_365
          past_average_night_rate_365
          available_nights_365
          past_available_nights_365
          bookable_nights_365
          past_bookable_nights_365
          cleaning_fee
          currency
          past_booked_nights
          los_365_0
          los_0_365
          past_leadtime
          leadtime_365
      }
      rooms {
          ...RoomFields
      }
  }
	`